export const ROUTES = {
	INDEX: "/",
	LOGIN: "/signin",
	SIGINUP: "/signup",
	FORGOTPASSWORD: "/forgot-password",
	RESETPASSWORD: "/reset-password",
	NEWPASSWORD: "/new-password",
	DASHBOARD: "/home",
	VERIFICATION: "/verify-account",
	ACCOUNTSETUP: "/account-setup",
	VENDORS: "/vendors",
	REGISTRY: "/registry",
	SHOP: "/shop",
	OURSTORY: "/our-story",
	OURPHOTOS: "/our-photos",
	MAKENOTES: "/make-notes",
	MAKEPLANS: "/make-plans",
	SETTINGS: "/settings",
	INVITEFRIEND: "/invite-friend",
	FAQ: "/faq",
	RATEUS: "/rate-us",
	BECOMEAVENDOR: "/become-a-vendor",
	PLANWEDDING: "/wedding-planner",
	WALLET: "/wallet",
	RESETPIN: "/reset-pin",
	TIMELINE: "/timeline",
	TIMELINEPOSTDETAIL: "/timeline/post/:id",
	NOTIFICATIONS: "/notifications",
	PROFILE: "/profile",
	VIEWVENDOR: "/vendors/view/:id",
	SEARCH: "/search"
,
	ERRORPAGE: "*",
};
